// Unpublished Work © 2026 Deere & Company.

import t from 'tcomb';
import {DigitalUserAccountPhone} from './digital-user-account-phone';
import {DigitalUserAccountAddress} from './digital-user-account-address';

export const DigitalUserAccountCommunication = t.struct({
    emailAddress: t.maybe(t.String),
    mobilePhone: t.maybe(DigitalUserAccountPhone),
    homePhone: t.maybe(DigitalUserAccountPhone),
    workPhone: t.maybe(DigitalUserAccountPhone),
    address: t.maybe(DigitalUserAccountAddress)
}, {
    defaultProps: {
        emailAddress: '',
        mobilePhone: new DigitalUserAccountPhone({}),
        homePhone: new DigitalUserAccountPhone({}),
        workPhone: new DigitalUserAccountPhone({}),
        address: new DigitalUserAccountAddress({})
    },
    name: 'DigitalUserAccountCommunication',
    strict: true
});
